// Environment configuration
export const environment = {
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:3001",
  environment: process.env.REACT_APP_ENVIRONMENT || "development",
  debug: process.env.REACT_APP_DEBUG === "true",
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || "",
};

export default environment;
